export default __webpack_public_path__ + "static/media/bimb.3edecaf3.svg";